import React, { useEffect, useRef, useState } from "react";

function ScreenStream({ open, onClose }) {
  const [image, setImage] = useState("");
  const boxRef = useRef(null);
  const dragging = useRef(false);
  const offset = useRef({ x: 0, y: 0 });

  useEffect(() => {
    if (!open) return;

    const ws = new WebSocket(process.env.REACT_APP_STREAM_URL);

    ws.onmessage = (event) => {
      setImage("data:image/jpeg;base64," + event.data);
    };

    return () => ws.close();
  }, [open]);

  const startDrag = (e) => {
    dragging.current = true;
    const rect = boxRef.current.getBoundingClientRect();

    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;

    offset.current = {
      x: clientX - rect.left,
      y: clientY - rect.top
    };
  };

  const onDrag = (e) => {
    if (!dragging.current) return;

    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clientY = e.touches ? e.touches[0].clientY : e.clientY;

    boxRef.current.style.left = clientX - offset.current.x + "px";
    boxRef.current.style.top = clientY - offset.current.y + "px";
  };

  const stopDrag = () => {
    dragging.current = false;
  };

  useEffect(() => {
    window.addEventListener("mousemove", onDrag);
    window.addEventListener("mouseup", stopDrag);

    window.addEventListener("touchmove", onDrag);
    window.addEventListener("touchend", stopDrag);

    return () => {
      window.removeEventListener("mousemove", onDrag);
      window.removeEventListener("mouseup", stopDrag);
      window.removeEventListener("touchmove", onDrag);
      window.removeEventListener("touchend", stopDrag);
    };
  }, []);

  if (!open) return null;

  return (
    <div
      ref={boxRef}
      style={{
        position: "fixed",
        top: "80px",
        left: "80px",
        width: "420px",
        minWidth: "250px",
        minHeight: "200px",
        resize: "both",
        overflow: "hidden",
        background: "#000",
        borderRadius: "10px",
        border: "2px solid #444",
        zIndex: 9999,
        boxShadow: "0 0 15px rgba(0,0,0,0.6)"
      }}
    >
      <div
        onMouseDown={startDrag}
        onTouchStart={startDrag}
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "6px",
          background: "#222",
          color: "white",
          cursor: "move"
        }}
      >
        <span>Live Screen</span>

        <button
          onClick={onClose}
          style={{
            background: "red",
            color: "white",
            border: "none",
            padding: "3px 10px",
            cursor: "pointer"
          }}
        >
          X
        </button>
      </div>

      <img
        src={image}
        alt="screen"
        style={{
          width: "100%",
          height: "calc(100% - 32px)",
          objectFit: "contain"
        }}
      />
    </div>
  );
}

export default ScreenStream;